@if (status(); as s) {
  <div class="chip" [ngClass]="cssClass()"
       [matTooltip]="('INTEGRATIONS.STATUS_' + s + '_TOOLTIP') | translate"
       [matTooltipClass]="{ 'uzai-tooltip': true }">
    <div class="fx-row justify-content-center align-items-center">
      @if (isActive()) {
        <mat-icon fontSet="material-icons-outlined" inset inline class="mr-5">{{ icon() }}</mat-icon>
      }
      <span>{{ ('INTEGRATIONS.STATUS_' + s) | translate | uppercase }}</span>
    </div>
  </div>
} @else {
  <span class="light">-</span>
}
